// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--Eaw_3","play-button":"a10a3f92e9--play-button--gPSYP"};